//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgSwitchArrows } from '../icons/SwitchArrows';

export function SwitchArrowsIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgSwitchArrows} data-qa="SwitchArrowsIcon">
      <svg />
    </SvgIcon>
  );
}
